import { navigate } from 'gatsby'
import useCart from 'hooks/account/cart/useCart'
import useAddressRequireDict from 'hooks/account/lists/useAddressRequireDict'
import useOrderList from 'hooks/account/lists/useOrderList'
import useAccount from 'hooks/account/useAccount'
import * as React from 'react'
import CartSummary from 'theme/molecules/account/CartSummary'
import * as evt from 'theme/templates/Cart/event'
import useTranslations from 'hooks/useTranslations'

type Props = {
  isRestricted: boolean
}

export default function Summary({ isRestricted }: Props) {
  const t = useTranslations<'templates-Cart'>()
  const account = useAccount()
  const orders = useOrderList({ pageSize: 1 })
  const cart = useCart()
  const requireDict = useAddressRequireDict()

  const getEcoTax = (items) => {
    let ecoTaxNet = 0
    let ecoTaxGross = 0
    items.map((item) => {
      if (item.prices.ecoTaxNet || item.prices.ecoTaxGross) {
        ecoTaxNet += item.prices.ecoTaxNet * item.quantity
        ecoTaxGross += item.prices.ecoTaxGross * item.quantity
      }
    })
    return { ecoTaxNet, ecoTaxGross }
  }

  const handleCheckoutClick = () => {
    if (!account.context) return
    if (cart.setup && cart.data) evt.beginCheckout(cart.data)

    const { activeBillingAddress, activeShippingAddress } = account.context

    const billingValid = requireDict.isBillingValid(activeBillingAddress)
    const shippingValid = requireDict.isShippingValid(activeShippingAddress)
    const paypalOrderId = getPaypalOrderId(account.cart.data.totalPrice)

    if (!account.loggedIn) navigate('/checkout/login/')
    else if (paypalOrderId) navigate('/checkout/overview/?po=' + paypalOrderId)
    else if (!billingValid || !shippingValid) navigate('/checkout/address/')
    else if (account.checkoutVisited) navigate('/checkout/overview/')
    else if (orders.data?.length || 0 > 0) navigate('/checkout/overview/')
    else navigate('/checkout/payment/')
  }

  return (
    <div className="Summary">
      <CartSummary
        showPaypalButton
        btnLabel={t('to_checkout_text')}
        headline={t('orderdetails_overview')}
        onBtnClick={handleCheckoutClick}
        showShareCart
        ecoTax={getEcoTax(cart.data.items)}
        isRestricted={isRestricted}
        orderMinimumCheck
        showOrderProgressBar={true}
      />
    </div>
  )
}

/** when already payed with paypal express and amount did not change we navigate to overview page directly */
function getPaypalOrderId(totalPrice: number) {
  let paypalOrderId = ''
  const cacheS = sessionStorage.getItem('paypal-express')
  if (cacheS) {
    const cache = JSON.parse(cacheS)
    if (cache.price === totalPrice) {
      paypalOrderId = cache.po
    }
  }
  return paypalOrderId
}
